import { Inject, Options, Vue } from "vue-property-decorator";
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import ModalBox from "@/shared/components/modal-box/index.vue";
import { TrustAPI } from '@/shared/modules/trust-api';
import store from '@/trust-admin-app/store';
import { EventEmitter } from "events";
import { AppInsights } from '@/trust-admin-app/appInsights';
import { InvestigationCategory, InvestigationTypeView } from '@/shared/modules/typescript-trustapi-client/models';
import ErrorIndicator from '@/shared/components/error-indicator/error-indicator';

@Options({
  props: {
    chosenInvestigationType: {},
  },
  components: {
    ModalBox,
    LoadingIndicator,
    ErrorIndicator
  }
})
export default class AddEditModal extends Vue {
  private chosenInvestigationType!: InvestigationTypeView;

  private ai = new AppInsights;

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Inject({ from: 'investigationCategory', default: [] })
  private investigationCategory!: InvestigationCategory[];

  private formData: InvestigationTypeView = {};

  showAddEditModal!: boolean;

  private show = false;
  private isLoadingData = true;
  private errorLoadingData = false;
  private canSubmit = false;
  private submitting = false;
  private isEdit = false;

  mounted(): void {
    this.show = this.showAddEditModal;
    this.isEdit = this.chosenInvestigationType?.id > 0;
    this.init();
  }

  private init(): void {
    try {
      this.isLoadingData = true;
      this.errorLoadingData = false;
      this.formData = JSON.parse(JSON.stringify(this.chosenInvestigationType));
    } catch (error) {
      this.errorLoadingData = true;
    } finally {
      this.isLoadingData = false;
    }
  }

  private cancelClicked() {
    this.closeModal();
  }

  private closeModal() {
    this.$emit('closeModal');
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private async submit() {
    this.isLoadingData = true;
    this.submitting = true;
    const investigationTypeRequest = {
      id: this.formData.id,
      defaultInvestigationCategoryId: this.formData.defaultInvestigationCategory.id,
      name: this.formData.name,
      expectedDuration: this.formData.expectedDuration,
      statusId: this.formData.status.id
    }
    await this.apiService.ConfigTrustApi?.apiV2ConfigTrustSaveInvestigationTypePost(investigationTypeRequest)
      .then(() => {
        if (this.isEdit) {
          this.eventCtrl.emit('show-snackbar', 'success', 'Updated Successfully');
        } else {
          this.eventCtrl.emit('show-snackbar', 'success', 'Added Successfully');
        }
        this.$emit("updateData");
        this.isLoadingData = false;
        this.submitting = false;
        this.closeModal();
      })
      .catch(error => {
        this.isLoadingData = false;
        this.submitting = false;
        this.eventCtrl.emit('show-snackbar', 'error', error);
        this.ai.trackException('Error getting investigation type: ' + error);
      });
  }

  private mandatoryCheck() {
    if (this.formData.name !== '' && this.formData.expectedDuration > 0) {
      this.canSubmit = true;
    } else {
      this.canSubmit = false;
    }
  }
}

